import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import { getEtikaState } from './helpers';

import { LenderStatus } from '../constants';

interface EtikaStatusContentHook {
  state: LenderStatus;
}

export default function useEtikaStatusContent(): EtikaStatusContentHook {
  const { job, credit, deposit, isLoading } = useStatusContext();

  const state = useMemo((): LenderStatus => {
    if (isLoading || !job || !credit) return 'loading';
    return getEtikaState(job, credit, deposit);
  }, [job, credit, deposit, isLoading]);

  return {
    state,
  };
}
